import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Se quema una luz y no sabés qué hacer', 'Un enchufe no funciona', 'Te da miedo tocar la electricidad', 'Dependés de alguien para arreglar cosas', 'Pagás caro arreglos simples', 'Querés aprender pero nadie te explica fácil', 'No sabés por dónde empezar'];
  return <section className="py-0 bg-white px-4 relative" data-id="element-138">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-200 to-transparent" data-id="element-139" />

      <div className="max-w-5xl mx-auto" data-id="element-140">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-141">
          {/* Stats row */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto mb-10" data-id="element-142">
            <div className="bg-brand-50 border border-brand-100 rounded-2xl p-4" data-id="element-143">
              <p className="text-3xl md:text-4xl font-heading font-extrabold text-brand-600" data-id="element-144">
                +300
              </p>
              <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-145">
                Descargas
              </p>
            </div>
            <div className="bg-brand-50 border border-brand-100 rounded-2xl p-4" data-id="element-146">
              <p className="text-3xl md:text-4xl font-heading font-extrabold text-brand-600" data-id="element-147">
                6+6
              </p>
              <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-148">
                Tomos + Bonos
              </p>
            </div>
            <div className="bg-brand-50 border border-brand-100 rounded-2xl p-4" data-id="element-149">
              <p className="text-3xl md:text-4xl font-heading font-extrabold text-brand-600" data-id="element-150">
                4.9<span className="text-lg text-gray-400" data-id="element-151">/5</span>
              </p>
              <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-152">
                Calificación ⭐
              </p>
            </div>
            <div className="bg-brand-50 border border-brand-100 rounded-2xl p-4" data-id="element-153">
              <p className="text-3xl md:text-4xl" data-id="element-154">🇦🇷</p>
              <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-155">
                Todo el país
              </p>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-gray-900" data-id="element-156">
            Si esto te pasa, este Mega Pack es para vos:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16" data-id="element-157">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-white border border-brand-100 shadow-sm hover:shadow-md hover:border-brand-300 transition-all p-5 rounded-2xl flex items-start gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-158">
              <XCircle className="w-6 h-6 text-brand-400 flex-shrink-0 mt-0.5" data-id="element-159" />
              <p className="text-gray-700 font-medium" data-id="element-160">{point}</p>
            </motion.div>)}
        </div>

        <motion.div className="bg-brand-50 border border-brand-200 rounded-3xl p-8 md:p-10 text-center max-w-3xl mx-auto shadow-sm relative overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-161">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-200/50 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-162" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-accent-200/50 rounded-full blur-2xl -ml-10 -mb-10" data-id="element-163" />

          <p className="text-2xl md:text-3xl font-heading font-bold text-gray-900 leading-tight relative z-10" data-id="element-164">
            No necesitás ser electricista. <br className="hidden md:block" data-id="element-165" />
            <span className="text-brand-600" data-id="element-166">
              Necesitás saber electricidad básica para tu casa.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}